import styled, { css } from 'styled-components'
import { space, layout } from 'styled-system'
import { FONT_FAMILY } from 'utils/Constants'

export const buttonStyles = css`
  background-color: ${(props) => props.theme.colors.inverseColor};
  border: none;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: ${FONT_FAMILY.PROXIMA_NOVA};
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.4;
  padding: 0.5rem 1rem;
  text-align: center;
  text-decoration: none;
  user-select: none;
  white-space: nowrap;

  :hover {
    background-color: ${(props) => props.theme.colors.secondary};
    transition: all 0.2s ease-in-out;
  }

  :disabled {
    background-color: rgb(177, 177, 181);
    cursor: auto;
  }
  ${space}
  ${layout}
`

export const Button = styled.button`
  ${buttonStyles}
`

export const Link = styled.a`
  ${buttonStyles}
`
